// extracted by mini-css-extract-plugin
export default {"container":"FieldLabel_container__AMG9G","small":"FieldLabel_small__XnzUb","big":"FieldLabel_big__TzB9p"};